import { selectAssignment } from '@redux/experiments/selectors/index';
import type { MobileMapViewV2Assignment } from 'types/experiments';
import type { State } from 'types/redux';

export const mobileMapViewV2AssignmentSelector = (state: State) => {
	if (!state.viewport.isMobile || state.category.code !== 'REC') {
		return null;
	}

	return selectAssignment(state, [
		'mobileMapViewV2',
	]) as MobileMapViewV2Assignment;
};
